/**
 * PATH: packages/ui/src/components/email/addressTarget.ts
 * FILE_ID: UI-EMAIL-ADDRESS-TARGET-001
 * PURPOSE: Resolve the email address under the pointer for copy actions.
 * WHY: A reader-level copy used to always take the sender, so a Cc chip
 *      copied the From address. The attribute lives on the chip itself;
 *      closest() starts at that node, so a parent must not wear it too.
 */
export const EMAIL_ADDRESS_ATTR = 'data-quotech-address'

export function addressFromEventTarget(target: EventTarget | null): string | null {
  const element = target instanceof Element
    ? target
    : target instanceof Node
      ? target.parentElement
      : null
  if (!element) return null
  const node = element.closest(`[${EMAIL_ADDRESS_ATTR}]`)
  const value = node?.getAttribute(EMAIL_ADDRESS_ATTR)?.trim() ?? ''
  return value || null
}

/** Pointer address wins. Sender is the fallback when the pointer is not on one. */
export function resolveCopiedAddress(
  pointerAddress: string | null | undefined,
  senderAddress: string | null | undefined,
): string {
  const pointer = pointerAddress?.trim() ?? ''
  if (pointer) return pointer
  return senderAddress?.trim() ?? ''
}
